import React from 'react';
import {
  Grid,
  IconButton,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import {DeleteOutlined, Close} from '@mui/icons-material';

import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import FullScreenLoader from '@components/loaders/full-screen-loader/FullScreenLoader';
import {DrawerDiv} from './WidgetsViewPageStyle';

const WidgetsViewPage = (props: any): React.ReactElement => {
  const {droppedComponents} = props;
  const [isPageLoading] = React.useState<boolean>(false);
  const [isComponentLoading] = React.useState<boolean>(false);
  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);
  const [selectedWidget, setSelectedWidget] = React.useState<
    number | undefined
  >();

  const handleWidgetClick = (index: number): void => {
    setSelectedWidget(index);
    setOpenDrawer(true);
  };

  const closeDrawer = (event: React.KeyboardEvent | React.MouseEvent): void => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setOpenDrawer(false);
  };

  const renderDrawer = (): React.ReactElement => {
    return (
      <DrawerDiv
        anchor={'right'}
        open={openDrawer}
        onClose={closeDrawer}
        hideBackdrop={true}>
        <Grid container spacing={1.25} alignItems={'center'}>
          <Grid item xs={10}>
            <Typography variant="h1" component="h2">
              Field Properties
            </Typography>
          </Grid>

          <Grid item xs={2}>
            <IconButton
              color="inherit"
              aria-label="delete"
              size="small"
              onClick={closeDrawer}>
              <Close color="primary" />
            </IconButton>
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="field-name-id"
              label="Field Name"
              variant="standard"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="field-link-name-id"
              label="Field Link Name"
              variant="standard"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h1" component="h2" mt={1}>
              Validation
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel label="Mandatory" control={<Checkbox />} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h1" component="h2" mt={1}>
              Visibility
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="demo-simple-select-standard-label">
                Show Field to
              </InputLabel>

              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                fullWidth
                label="Show Field to">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'Admin'}>Admin</MenuItem>
                <MenuItem value={'User'}>User</MenuItem>
                <MenuItem value={'Manager'}>Manager</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Divider style={{marginTop: '0.5rem'}} />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h1" component="h2" mt={1}>
              Appearance
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="demo-simple-select-standard-label">
                Field Type
              </InputLabel>

              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                fullWidth
                label="Field Type">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'Admin'}>Text</MenuItem>
                <MenuItem value={'User'}>Number</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="demo-simple-select-standard-label">
                Field Size
              </InputLabel>

              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                fullWidth
                label="Field Size">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'Admin'}>Small</MenuItem>
                <MenuItem value={'User'}>Medium</MenuItem>
                <MenuItem value={'Manager'}>Large</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DrawerDiv>
    );
  };

  const renderDragDropBox = (): React.ReactElement => {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        style={{height: '100%'}}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{
            height: '15rem',
            width: '15rem',
            border: '1px dashed #4D4D4D80',
            cursor: 'pointer'
          }}>
          Drag a field here
        </Grid>
      </Grid>
    );
  };

  const renderDroppedComponents = (): React.ReactElement => {
    if (droppedComponents?.length > 0) {
      return (
        <Grid container>
          {droppedComponents.map((item: any, index: any) => {
            return (
              <Grid
                item
                container
                xs={5.75}
                key={index}
                onClick={() => handleWidgetClick(index)}
                alignItems={'center'}
                justifyContent={'center'}
                style={{
                  border: `1px dashed ${
                    selectedWidget === index ? '#1976D2' : '#e6e6e6'
                  }`,
                  borderRadius: '0.5rem',
                  padding: '0.5rem 1rem',
                  margin: '0 1rem 1rem 0',
                  cursor: 'pointer'
                }}>
                <Grid
                  item
                  xs={11}
                  style={{
                    color: `${selectedWidget === index ? '#1976D2' : '#000'}`
                  }}>
                  {item}
                </Grid>
                <Grid item xs={1}>
                  {selectedWidget === index && (
                    <IconButton
                      color="inherit"
                      aria-label="delete"
                      size="small">
                      <DeleteOutlined />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      );
    } else {
      return renderDragDropBox();
    }
  };

  return isPageLoading ? (
    <FullScreenLoader />
  ) : isComponentLoading ? (
    <ComponentLoader />
  ) : (
    <>
      {renderDroppedComponents()}
      {openDrawer && renderDrawer()}
    </>
  );
};

export default WidgetsViewPage;
